import { useNavigate, Link } from "react-router-dom";
import PageLayout from "@/components/site/PageLayout";
import PageHeader from "@/components/site/PageHeader";
import Services from "@/components/site/Services";
import CTABand from "@/components/site/CTABand";
import SEO from "@/components/site/SEO";
import { Reveal } from "@/components/site/motion";
import { SERVICES } from "@/lib/services";
import { ArrowUpRight } from "lucide-react";

export default function ServicesPage() {
  const navigate = useNavigate();
  return (
    <PageLayout testid="services-page">
      <SEO
        title="Invisible Grill Services in Hyderabad | Sudeeksha"
        description="Invisible grill services in Hyderabad — balcony invisible grills, child safety grills, SS316 marine grade & custom frameworks. Professional installation. Free site visit."
        path="/services"
      />
      <PageHeader
        eyebrow="What we install"
        title={["Our", "Services"]}
        crumb="Services"
        subtitle="Premium invisible grill solutions for balconies, windows, staircases and high-rise apartments — engineered for safety and finished with precision."
      />
      <Services onQuote={() => navigate("/contact")} />

      {/* Specialised services deep-links */}
      <section className="py-20 md:py-24 bg-steel-50 border-t border-steel-200">
        <div className="max-w-[1200px] mx-auto px-5 md:px-10">
          <Reveal className="mb-10 max-w-xl">
            <p className="font-label text-xs tracking-[0.3em] uppercase text-steel-500 mb-4">Explore specific services</p>
            <h2 className="font-display font-black tracking-tighter text-steel-900 text-3xl md:text-5xl leading-none">
              Pick the one you need.
            </h2>
          </Reveal>
          <div className="grid md:grid-cols-2 gap-5" data-testid="service-detail-links">
            {SERVICES.map((s, i) => (
              <Reveal key={s.slug} delay={i * 0.08}>
                <Link
                  to={`/services/${s.slug}`}
                  data-testid={`service-link-${s.slug}`}
                  className="group flex items-start justify-between gap-6 border border-steel-200 bg-white p-7 hover:border-steel-900 transition-colors"
                >
                  <div>
                    <div className="font-display font-black text-xl text-steel-900 group-hover:text-steel-900">{s.name}</div>
                    <p className="text-steel-600 mt-3 leading-relaxed">{s.metaDesc}</p>
                  </div>
                  <ArrowUpRight className="text-steel-400 group-hover:text-gold-500 transition-colors shrink-0" size={24} />
                </Link>
              </Reveal>
            ))}
          </div>
        </div>
      </section>

      <CTABand />
    </PageLayout>
  );
}
